import {Pipe, PipeTransform} from "@angular/core";
import {StandardName} from "../../store/state/order.state";

@Pipe({
    name: 'standardName',
    standalone: false
})
export class StandardNamePipe implements PipeTransform {

	transform(standardName: StandardName, fullName: boolean = false): string {
		if (fullName) {
			return this.standardNameFullName(standardName);
		}
		return standardName.replace('_', ' ');
	}

	private standardNameFullName(standardName: StandardName): string {
		if (standardName == StandardName.ISO_45001) {
			return standardName.replace('_', ' ') + ":2018";
		} else if (standardName == StandardName.ISO_27001) {
			return standardName.replace('_', ' ') + ":2013";
		} else if (standardName == StandardName.ISO_27701) {
			return standardName.replace('_', ' ') + ":2019";
		} else
			return standardName.replace('_', ' ') + ":2015";
	}
}
